import React from 'react';
import styled from 'styled-components';
import { Flexbox, TextInput } from '@ibinder/common-frontend';
import { apiServicpes } from '@ibinder/util-common-network-services';
import { ThemeButton } from '@ibinder/ui-common-core';
import { SingleSelect } from '@ibinder/common-frontend';
import { selectData } from '../../../../../../components/PrintProviders/pages/PrintProviderDetails/components/GeneralSettings/GeneralSettings.constants';
import { useMutation } from '@apollo/client';
import { CREATE_BRANDED_INVITE } from '../../../../../../api/mutations/createBrandedUserInvite.query';

const ModalWrapper = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-x: auto;
`;
const BottomActionBar = styled(Flexbox)`
  margin-top: auto;
  box-shadow: ${(p) => p.theme.shadows.primaryWithOpacity};
  padding: 1rem;
`;
export const CreateBrandedInviteForm =
  ({ t, language, onClose }) =>
  () => {
    const [UserFormValues, setUserFormValues] = React.useState({
      Email: '',
      Language: language,
      brandId: 'iBinder'
    });

    const [createBrandedInvite] = useMutation(CREATE_BRANDED_INVITE, {
      onCompleted: onClose
    });

    const onSubmit = () => {
      createBrandedInvite({
        variables: {
          body: {
            ...UserFormValues,
            Template: 'NewUserInvitation',
            domain: UserFormValues.brandId
          }
        }
      });
    };
    const brand = [
      { Key: 'iBinder', Value: 'iBinder' },
      { Key: 'SundaHus', Value: 'SundaHus' }
    ];
    const activeIndexBrand = brand.findIndex(
      (f) => f.Key === UserFormValues.brandId
    );

    const languages = selectData.language;

    const activeIndexLanguage = languages.findIndex(
      (f) => f.Key === UserFormValues.Language
    );

    return (
      <>
        <ModalWrapper>
          <p>{t('brandedInviteIntroduction')}</p>
          <TextInput
            label={t('email')}
            value={UserFormValues.Email}
            changeValue={({ target }) =>
              setUserFormValues({
                ...UserFormValues,
                Email: target.value
              })
            }
          />
          <SingleSelect
            label={t('brand')}
            dropdownText={t('brand')}
            dropdownData={brand}
            onClickSelectItem={(index) => {
              setUserFormValues({
                ...UserFormValues,
                brandId: brand[index].Key
              });
            }}
            activeIndex={activeIndexBrand}
            withSortButton={false}
          />
          <SingleSelect
            label={t('language')}
            dropdownText={t('language')}
            dropdownData={languages}
            onClickSelectItem={(index) => {
              setUserFormValues({
                ...UserFormValues,
                Language: languages[index].Key
              });
            }}
            activeIndex={activeIndexLanguage}
            withSortButton={false}
          />
        </ModalWrapper>
        <BottomActionBar justifyContent="space-between">
          <ThemeButton buttonType="default" onClick={() => onClose()}>
            {t('Cancel')}
          </ThemeButton>

          <ThemeButton buttonType="primary" onClick={onSubmit}>
            {t('SendInvite')}
          </ThemeButton>
        </BottomActionBar>
      </>
    );
  };
